import { connect } from 'react-redux'
import { Component } from "react"

import {client, xml} from '@xmpp/client'

import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import {onUserActionCaravanserail} from "../actions"
import { Carousel } from '@mantine/carousel';
import{getBoundingRec} from "../game/help"
import ChatWidget from "./Chat/ChatWidget.jsx"
//import {createXMPPConnexion, default_avatar} from '../game/jabber.jsx'
import{__, Capitalize} from "../traslates/blabla"


import {
    Modal,
    Container,
    ActionIcon,
    Image as MantineImage,
    Flex,
    Group,
    Overlay,
    Loader,
    Tabs, Table, Avatar
  } from "@mantine/core";

  import {IconEye, IconBuildingStore} from '@tabler/icons-react';
import { statsBuffer } from 'motion';
import { element } from 'three/src/nodes/TSL.js';


let xmpp_init = false


const pathContext = {
    scene3D: null,
    loading: 1,
    user: undefined,
    objectsScene: {},
    currentSelection: null,
    currentHighlight:null,
    height: "mini",
    version: 0,
    
    caravanserails:[],
    produits_coordonnees: {}
}

let objectMaxX = 100
let objectMaxY = 75

let rebon = false
class UserInterface extends Component{

    mountedScenes = new Set();
    loading = 1;
    sharedRenderer = null;
    images={}

    constructor(props) {
        super(props)
        this.state = pathContext
        this.state.user = JSON.parse(JSON.stringify(props.user))
        //this.state.user.avatar = default_avatar
        
    }

    static getDerivedStateFromProps(props, state) {
        if(props.caravanserails){
            /*if(state.caravanserails){ 
                if(JSON.parse(JSON.stringify(props.caravanserails)) !== JSON.parse(JSON.stringify(state.caravanserails))){ 
                    const caravanserails = state.car avanserails
                    const users = {}
                    
                    for(var i=0; i < caravanserails.length; i ++){
                        const c = caravanserails[i]
                        if(!c.users) continue
                        for(let n=0; n < c.users.length; n ++){
                            users[c.users[n].id] = c.users[n]
                        }
                    }

                    for(var i=0; i < props.caravanserails.length; i ++){
                        const c = props.caravanserails[i]
                        if(!c.users) continue
                        for(let n=0; n < c.users.length; n ++){
                            if(users[c.users[n].id]){
                                c.users[n] = users[c.users[n].id]
                            }
                        }
                    }

                    state.caravanserails = JSON.parse(JSON.stringify(props.caravanserails))
                }
            } else {
                state.caravanserails = JSON.parse(JSON.stringify(props.caravanserails))
            }*/

            /*if(!state.caravanserails || !state.caravanserails.length){ 
                state.caravanserails = JSON.parse(JSON.stringify(props.caravanserails))
                return state;
            }*/

                
            if(!state.caravanserails.length && props.caravanserails.length > 0){ 
                state.caravanserails = JSON.parse(JSON.stringify(props.caravanserails))
                state.currentSelection = state.caravanserails[0];
                return state;
            }
        }
        return null
    }

    getItemBgdIndex(nom){

        const t = this.state.produits_coordonnees[nom]
        if(t){
            const i = 1 + Math.floor(t.x/t.width)
            const j = 1 + Math.floor(t.y/t.height)
            return `${i}-${j}`
        }
        return '1-1'
    }
    isComponentMount = false
    async componentDidMount() {
        
        if(this.isComponentMount) return
        this.isComponentMount = true
        
        setTimeout(async ()=>{

            const response = await fetch("/produits/produits_coordonnees.json", {
                method: "GET",
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
                }
            })
    
    
            if(response.status === 200) {
                const produits_coordonnees = await response.json();
                const state = this.makeStateCopy()
                state.produits_coordonnees = produits_coordonnees
                this.loading --
                this.setState(state)
            }

        }, 10)
        

        this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
            console.log("Scene3D", msg)
            if(msg.container !== "map-world") return
            const state = this.makeStateCopy()
            state.scene3D = arg
            this.setState(state)
        })

        setTimeout(()=>{
            console.log("Scene3DAsk")
            this.props.notification.onNotification("Scene3DAsk", {}, {})
        }, 500)

        
        
        this.props.notification.addNotification("UserAvatarReady", async (type, msg, arg)=>{
            const state = this.makeStateCopy()
            try{ 
                for(var i=0; i < this.state.currentSelection.users.length; i ++){
                    const c = this.state.currentSelection.users[i]
                    
                    if(c.id === msg.id){
                        if(c.avatar !== arg){
                            c.avatar = arg
                            this.setState(state)
                            break
                        }
                        
                    }
                }
            }catch{}
            
        })

        this.props.notification.addNotification("ObjectSelection", async (type, msg, arg)=>{
            
            setTimeout(()=>{
                this.props.notification.onNotification("Object3DClearSelection", {}, {})
            }, 100)
            
            
            this.props.onUserActionCaravanserail('open')
            this.onSelectCaravanserail(msg.selection.uid)
            
        })
    }
    

    onSelectCaravanserail(uid){
        if(this.state.caravanserails && this.state.caravanserails.length > 0){
            for(var i=0; i < this.state.caravanserails.length; i ++){
                if(!uid||this.state.caravanserails[i].uid === uid){
                    setTimeout(()=>{
                        const state = this.makeStateCopy()
                        state.currentSelection = this.state.caravanserails[i]
                        this.setState(state)
                    }, 100)
                    break;

                }
            }
        }else{
            let tentative = 0
            const t = setInterval(()=>{
                if(this.state.caravanserails && this.state.caravanserails.length > 0){
                    clearInterval(t)
                    for(var i=0; i < this.state.caravanserails.length; i ++){
                        if(!uid || this.state.caravanserails[i].uid === uid){
                            setTimeout(()=>{
                                const state = this.makeStateCopy()
                                state.currentSelection = this.state.caravanserails[i]
                                this.setState(state)
                            }, 100)
                            
                            break;

                        }
                    }
                    
                } else {
                    tentative ++
                    if(tentative >= 15){
                        clearInterval(t)
                    }
                }

            }, 200)
        }

    }

    makeStateCopy(){
        return {
            scene3D: this.state.scene3D,
            loading: this.state.loading,
            user: this.state.user,
            is_mini: this.state.is_mini,
            //lastMessage: this.state.lastMessage,
            objectsScene: this.state.objectsScene,
            caravanserails: this.state.caravanserails,
            currentSelection: this.state.currentSelection,
            currentHighlight: this.state.currentHighlight,
            version: this.state.version + 1
        }
    }

    MAX_CONCURRENCY = 2;
    _inflight = 0;
    _queue = [];
    _withSlot(task) {
        return new Promise(async (resolve, reject) => {
            const enter = async () => {
            this._inflight++;
            try { resolve(await task()); }
            catch (e) { reject(e); }
            finally {
                this._inflight--;
                const next = this._queue.shift();
                if (next) next();
            }
            };
            (this._inflight < this.MAX_CONCURRENCY) ? enter() : this._queue.push(enter);
        });
    }

    createRenderer(width, height) {
        if (this.sharedRenderer) return this.sharedRenderer;
      
        const r = new THREE.WebGLRenderer({
          antialias: false,
          alpha: true,
          preserveDrawingBuffer: false,
          powerPreference: 'high-performance',
        });
        r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
        r.setSize(width, height, false);
        r.setClearColor(0x000000, 0);
      
        // Debug utile si contexte perdu
        r.getContext().canvas.addEventListener('webglcontextlost', (e) => {
          e.preventDefault();
          console.warn('[WEBGL] context lost (carousel)');
        }, { passive: false });
      
        this.sharedRenderer = r;
        return r;
    }
          


      mountScene (node, elm, position) {
        if (!node || !elm || !elm.uid) return;
        /*if (this.mountedScenes.has(elm.uid)){

            
            return;
        }
      
        this.mountedScenes.add(elm.uid);*/
        this.renderSceneInto(node, elm);
      };

      async renderGLTFToImagesMap(renderer, url, uid, size) {
        if (this.images[uid]) return this.images[uid];
      
        return this._withSlot(async () => {
          const loader = new GLTFLoader();
          const gltf = await loader.loadAsync(url);
      
          const scene = new THREE.Scene();
          const light = new THREE.DirectionalLight(0xffffff, 1.2);
          light.position.set(1, 1, 2);
          scene.add(light);
      
          const root = gltf.scene;
          const box = new THREE.Box3().setFromObject(root);
          const center = box.getCenter(new THREE.Vector3());
          const sizeBox = box.getSize(new THREE.Vector3());
          root.position.sub(center);
          scene.add(root);
      
          const fov = 30, aspect = size.w / size.h;
          const camera = new THREE.PerspectiveCamera(fov, aspect, 0.01, 1000);
          const maxDim = Math.max(sizeBox.x, sizeBox.y, sizeBox.z);
          const dist = (maxDim / 2) / Math.tan((fov * Math.PI) / 360);
          camera.position.set(dist * 0.5, dist * 0.0, dist * 0.6);
          camera.lookAt(0, 0, 0);
      
          renderer.setSize(size.w, size.h, false);
          renderer.render(scene, camera);
      
          // ⚠️ Préfère toBlob (moins de pics mémoire que toDataURL)
          const blob = await new Promise(res =>
            renderer.domElement.toBlob(res, 'image/webp', 0.9)
          );
          const urlBlob = URL.createObjectURL(blob);
          const img = new Image();
          img.width = size.w; img.height = size.h;
          img.onload = () => { URL.revokeObjectURL(urlBlob); };
          img.src = urlBlob;
      
          // cache
          this.images[uid] = img;
      
          // ménage mémoire GLTF
          this.disposeObject3D(root);
          scene.clear();
          gltf.parser?.dispose?.();
      
          return img;
        });
      }
      
      

      async renderSceneInto (container, elm){

        if (!container) return;
        // si déjà une image dans CE container, ne rien faire
        if (container.querySelector('img.image3DCaroussel')) return;

        const w = Math.round((objectMaxX * 3) / 2);
        const h = Math.round((objectMaxY * 3) / 2);
        const renderer = this.createRenderer(w, h);

        const img = await this.renderGLTFToImagesMap(
            renderer,
            `/${elm.mesh3d.filename}`,
            elm.uid,
            { w, h }
        );
        if (container.querySelector('img.image3DCaroussel')) return;

        // clone pour éviter "arrachage" si la même image est utilisée ailleurs
        const clone = img
        clone.className = 'image3DCaroussel';
        container.innerHTML = '';
        container.appendChild(clone);
        
      };
      

    onClickElement(elm, position){
        const state = this.makeStateCopy()
        state.currentSelection = elm
        this.setState(state)
    }

    onGotoLngLatSelection(){
        if(this.state.scene3D && this.state.scene3D.map){
            
            this.state.scene3D.map.setZoom(13)
        }
        this.props.notification.onNotification("NavigateLngLat", this.state.currentSelection.lnglat)
        setTimeout(()=>{
            this.props.onUserActionCaravanserail('close')
        }, 200)
        
    }

    getCurrentCaravanSelection(){
        return this.state.currentSelection
    }

    getUserAvatar(user){
        
        if(user.avatar){
            return user.avatar
        }
        else{
            this.props.notification.onNotification("UserAvatar", user)
        }
    }

    onChatDialog(user){
        if(user.id === this.state.user.id){
            return;
        }
        this.props.onUserActionCaravanserail('close')
        setTimeout(()=>{
            this.props.notification.onNotification("onChatDialog", user)
        }, 100)
       
    }

    componentDidUpdate(props, prevState) {
        /*const state = this.makeStateCopy()
        if(!state.caravanserails.length && props.caravanserails.length > 0){ 
            state.caravanserails = JSON.parse(JSON.stringify(props.caravanserails))
            state.currentSelection = state.caravanserails[0];
            this.setState(state);
        }*/
    }

    disposeObject3D(obj) {
        obj.traverse(o => {
          if (o.geometry) { o.geometry.dispose(); }
          if (o.material) {
            const m = o.material;
            if (Array.isArray(m)) m.forEach(mm => this.disposeMat(mm)); else this.disposeMat(m);
          }
        });
    }
    disposeMat(m) {
        for (const key of ['map','normalMap','roughnessMap','metalnessMap','emissiveMap','aoMap']) {
          if (m[key]) { m[key].dispose(); }
        }
        m.dispose();
    }
    disposeRenderer(renderer) {
        try { renderer.getContext().getExtension('WEBGL_lose_context')?.loseContext(); } catch(e){}
        renderer.dispose?.();
      }
      

    onClose(){
        for (const uid in this.state.objectsScene) {
            const obj = this.state.objectsScene[uid];
            if (obj?.gltf?.scene) this.disposeObject3D(obj.gltf.scene);
        }
        if (this.controls) this.controls.dispose();
        if (this.renderer) { this.disposeRenderer(this.renderer); this.renderer = null; }
        this.props.onUserActionCaravanserail('close')
    }

    render() {
            /*if(this.state.caravanserails && this.state.caravanserails.length > 0 && !this.state.currentSelection){
                const state = this.makeStateCopy()
                state.currentSelection = this.state.caravanserails[0]
                setTimeout(()=>{
                    this.setState(state)
                }, 100)
            }*/
            return (
                <>
                    <Modal className='modal-caravanails' opened={this.props.caravanserailAction==='open' && this.state.caravanserails} onClose={()=>{ 
                        this.onClose()
                    }} title={this.state.currentSelection?(
                            <>
                                <span className='nom'>{Capitalize(this.state.currentSelection.nom||this.state.currentSelection.mesh3d.nom)}</span>
                                <ActionIcon variant="filled" aria-label="Settings" onClick={()=>{
                                    this.onGotoLngLatSelection()
                                }}><IconEye size={14}/></ActionIcon>
                                <span className='uid'>{this.state.currentSelection.uid}</span>
                            </>
                            
                        ):"Clickez pour Choisir"}>
                        <Flex>
                            
                            <Carousel className='carousel' width={100} height={75*4} orientation="vertical" slideGap="xs" slideSize="15%" withControls={false}>
                            { 
                                this.state.caravanserails.map((elm, position)=>(
                                    <Carousel.Slide key={position} onClick={()=>{this.onClickElement(elm, position)}} className={this.state.currentSelection && this.state.currentSelection.uid === elm.uid?'selected':""}>
                                        <div id={elm.uid}  className='caravanserail' style={{width: objectMaxX, height: objectMaxY}} ref={(node) => this.mountScene(node, elm, position)} >
                                            
                                        </div>
                                    </Carousel.Slide>
                                ))
                            }
                            </Carousel>
                            <Container size="xl" className='caravanserail-container'>
                                <Tabs defaultValue={__("Marché")}>
                                    <Tabs.List>
                                        <Tabs.Tab value={__("Marché")} leftSection={<IconBuildingStore size={12} />}>
                                        {__("Marché")}
                                        </Tabs.Tab>
                                        {this.state.currentSelection && this.state.currentSelection.users ? (
                                            <Tabs.Tab value={__("users")} leftSection={<IconBuildingStore size={12} />}>
                                            {__("users")}
                                            </Tabs.Tab>
                                        ):"" }
                                    </Tabs.List>
                                    <Tabs.Panel value={__("Marché")}>
                                        <Table>
                                            <Table.Thead>
                                                <Table.Th>{__("Nom")}</Table.Th>
                                                <Table.Th>{__("Achat")}</Table.Th>
                                                <Table.Th>{__("Vente")}</Table.Th>
                                            </Table.Thead>
                                            <Table.Tbody>
                                                {this.state.currentSelection ? 
                                                    this.state.currentSelection.properties["items"].map((item, index)=>(
                                                        <Table.Tr key={`itel-${index+1}`}>
                                                            <Table.Td><span className={`item _${this.getItemBgdIndex(item.nom)}`}></span><span>{item.nom}</span></Table.Td>
                                                            <Table.Td><span>{(item.prix*0.999).toFixed(1)}</span></Table.Td>
                                                            <Table.Td><span>{(item.prix*1.1).toFixed(1)}</span></Table.Td>
                                                        </Table.Tr>
                                                    )):''}
                                            </Table.Tbody>
                                        </Table>
                                    </Tabs.Panel>
                                    <Tabs.Panel value={__("users")}>
                                    {
                                        this.state.currentSelection && this.state.currentSelection.users ? 
                                            this.state.currentSelection.users.map((user, index)=>(
                                                <Group className='user'gap='xs' onClick={()=>this.onChatDialog(user)}>
                                                    <Avatar key={user.pseudo} name={user.pseudo} color="initials" src={this.getUserAvatar(user)}></Avatar>
                                                    <p>{user.pseudo}</p>
                                                </Group>
                                            )):""
                                    }

                                    </Tabs.Panel>
                                </Tabs>
                                
                            </Container>
                            
                        </Flex>
                        {this.loading ? (
                            <><
                                Overlay color="#000" backgroundOpacity={0.85} zIndex={10}/>
                                <Loader size={30} style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 200, // plus haut que Overlay
                                }}/>

                            </>
                            
                        ):""}
                    </Modal>
                    <Group className={`userInterface ${this.props.openCloseChatPrivate === 'close' ? 'mini' : 'must' }`} justify="center" gap={0}>
                        <ActionIcon className="caravanserails" size={40} variant={this.props.caravanserailAction === "close" ? "default" : ""} onClick={(e)=>{
                            if(this.props.caravanserailAction === "close"){ 
                                this.props.onUserActionCaravanserail('open')
                                this.onSelectCaravanserail()
                            }
                            else {

                                this.onClose()
                            }
                        }}>
                            <MantineImage radius="md" src="/commerces/original_commerce_icon_62x52.png" />
                        </ActionIcon>
                        
                        <ChatWidget user={this.state.user}/>
                    </Group>
                    
                </>
            )
        }
}

const mapDispatchToProps = {
    onUserActionCaravanserail: onUserActionCaravanserail,
    
}


const mapStateToProps = (state) => {
    return {
        notification: state ? state.notification : undefined,
        caravanserailAction: state.caravanserailAction !== undefined ? state.caravanserailAction : 'close',
        caravanserails: state.caravanserails||[],
        openCloseChatPrivate: state.openCloseChatPrivate||"close",
        caravanserailSelection: state.caravanserailSelection||null
    }
}

UserInterface = connect(mapStateToProps, mapDispatchToProps)(UserInterface);

export default UserInterface;
